import Vue from "vue";

import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import { Component, Watch } from "@/decorators";
import { addMonths, firstDayOfMonth, lastDayOfMonth } from "@/utils/common/date";

@Component({
    components: {
        dateTimePickerComponent,
        comboComponent,
    },
})
export default class PeriodoFiltroComponent extends Vue {
    private periodo = 1;
    private periodoOptions: Array<Object> = [
        { text: "Mês atual", value: 1 },
        { text: "Mês anterior", value: 2 },
        { text: "Ano atual", value: 3 },
        { text: "Customizado", value: 4 },
    ];

    private timer = null;

    private dataInicial = firstDayOfMonth(new Date());
    private dataFinal = new Date();

    @Watch("periodo")
    private onPeriodoChange() {
        switch (this.periodo) {
            case 1:
                this.dataInicial = firstDayOfMonth(new Date());
                this.dataFinal = new Date();
                break;
            case 2:
                this.dataInicial = addMonths(-1, firstDayOfMonth(new Date()));
                this.dataFinal = lastDayOfMonth(this.dataInicial);
                break;
            case 3:
                this.dataInicial = new Date(new Date().getFullYear(), 0, 1);
                this.dataFinal = new Date();
                break;
            case 4:
                break;
        }
    }

    private onFilter() {
        if (this.dataInicial > this.dataFinal) {
            this.$showWarning("Atenção", "Data Inicial maior que Data Final");
            return;
        }

        this.$emit("onFilter", this.dataInicial, this.dataFinal);
    }

    private mounted() {
        setTimeout(() => {
            this.onFilter();
        }, 1000);

        this.timer = setInterval(this.onFilter, 1000 * 60 * 10); //10 minutos
    }

    private beforeDestroy() {
        clearInterval(this.timer);
    }
}
